import { useEffect } from 'react';
import { setUserContext, addBreadcrumb } from '../lib/sentry';

// Hook para configurar contexto do usuário no Sentry
export const useSentryUser = (user: { id: string; email?: string; name?: string } | null) => {
  useEffect(() => {
    if (user) {
      setUserContext(user);
      addBreadcrumb(`User logged in: ${user.email}`, 'auth');
    }
    // Depende dos campos usados, não do objeto `user` inteiro — o chamador (AuthContext)
    // passa um objeto literal novo a cada render, e o próprio Supabase emite uma
    // referência nova para a mesma pessoa sempre que a aba volta a ficar visível.
  }, [user?.id, user?.email, user?.name]);
};

// Hook para adicionar breadcrumbs de navegação
export const useSentryNavigation = (route: string) => {
  useEffect(() => {
    addBreadcrumb(`Navigated to ${route}`, 'navigation', { route });
  }, [route]);
};

// Hook para capturar erros de API
export const useSentryApiErrors = () => {
  const captureApiError = (error: Error, endpoint: string, method: string) => {
    addBreadcrumb(`API Error: ${method} ${endpoint}`, 'http', {
      endpoint,
      method,
      error: error.message,
    });
  };

  return { captureApiError };
}; 